import { CALL_API } from "../middleware/api";
import iamApi from "../api/IamApi";
import {
  GET_WALLET_FAILURE,
  GET_WALLET_REQUEST,
  GET_WALLET_SUCCESS,
} from "./walletActions";
import { IActionsCreator } from "../types/action";

export const WalletActionsCreator = {
  getWalletItems: (
    clientId: string,
    accountV2: string,
    successHandler?: any,
    failureHandler?: any
  ): IActionsCreator => ({
    [CALL_API]: {
      types: [GET_WALLET_REQUEST, GET_WALLET_SUCCESS, GET_WALLET_FAILURE],
      request: () => {
        if (!accountV2 || accountV2?.toLowerCase() === "false") {
          return iamApi.ezpay.getWalletItems(clientId);
        } else {
          return iamApi.ezpay.getWalletItemsV2(clientId);
        }
      },
      successHandler,
      failureHandler,
    },
  }),
  getPayableWalletItems: (
    clientId: string,
    successHandler?: any,
    failureHandler?: any
  ): IActionsCreator => ({
    [CALL_API]: {
      types: [GET_WALLET_REQUEST, GET_WALLET_SUCCESS, GET_WALLET_FAILURE],
      request: () => iamApi.ezpay.getPayableWalletItems(clientId),
      successHandler,
      failureHandler,
    },
  }),
};

export default WalletActionsCreator;
